import { css } from '@emotion/react';
import { styled } from '@mui/joy';

import { MainButtonGroup } from '@/components/form-elements/MainButtonGroup';

export const ModalMainButtonGroup = styled(MainButtonGroup)(
  () => css`
    padding: 0;
  `,
);
